import type { ComponentType } from "react";
import type { ModuleDefinition, SlotProps } from "../../core/platform/registry/registry";
import { BooksActions } from "./ui/BooksActions";

// Module-owned styles: switching books off leaves no stylesheet behind.
import "./ui/books.css";

/**
 * The books module, assembled (specs/005-bookkeeping).
 *
 * IT SUBSCRIBES TO NOTHING. The books read the till's journal — sales, tenders,
 * shift counts, paid-outs — on the server; they never write it and never need
 * to hear about a sale as it happens. Its whole terminal surface is one
 * `terminal.actions` component carrying two buttons: Cash out, for whoever is
 * on shift, and Books, for owners and managers.
 */
export function createBooksModule(): ModuleDefinition {
  return {
    id: "books",
    name: "Books",
    version: "0.1.0",
    slots: {
      "terminal.actions": BooksActions as ComponentType<SlotProps>,
    },
  };
}

export default createBooksModule;
